(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/prescript.js');

'use strict';

svs.grassroots = svs.grassroots || {};
svs.grassroots.components = svs.grassroots.components || {};
svs.grassroots.components.searchbar_section = svs.grassroots.components.searchbar_section || {};
svs.grassroots.components.start_info_section = svs.grassroots.components.start_info_section || {};
svs.grassroots.components.receiver = svs.grassroots.components.receiver || {};
svs.grassroots.components.result = svs.grassroots.components.result || {};
svs.grassroots.components.search_results = svs.grassroots.components.search_results || {};
svs.grassroots.pages = svs.grassroots.pages || {};
svs.grassroots.store = svs.grassroots.store || {};
svs.grassroots.utils = svs.grassroots.utils || {};
svs.grassroots.context = svs.grassroots.context || {};

svs.grassroots.shared = svs.grassroots_shared_2 || {};
svs.grassroots.shared.data = svs.grassroots.shared.data || {};
svs.grassroots.shared.data.config = svs.grassroots.shared.data.config || {};
svs.grassroots.tenant = svs.grassroots.shared.data.isCorporateSite ? 'neutral' : svs.core.detect.tenant('lb') ? 'sport' : 'tur';
const sanitise = str => str.replace(/å/g, 'a').replace(/Å/g, 'A').replace(/ä/g, 'a').replace(/Ä/g, 'A').replace(/ö/g, 'O').replace(/Ö/g, 'O').replace(/ /g, '-').toLowerCase();
const single = 'forening';
svs.grassroots.links = {
  start: '/',
  singlePattern: "/".concat(single, "/:id"),
  single: (id, shortname) => "/".concat(single, "/").concat(id, "-").concat(sanitise(shortname || '')),
  search: '/sok',
  query: q => "/sok?q=".concat(q),
  sanitise,
  result: '/sagickdet/:year',
  marketing: '/marknadsforing'
};

 })(window);